import { InputText } from 'primereact/inputtext';
import { Card } from 'primereact/card';
import { useEffect, useRef, useState } from 'react';
import './Search.scss'
import axios from 'axios';
import { ListBox } from 'primereact/listbox';
import { Toast } from 'primereact/toast';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { IField } from '../../features/layerSlice';
import { Slider } from 'primereact/slider';
import { AutoComplete } from 'primereact/autocomplete';
import { setFirmResult } from '../../features/searchResultSlice';
import { setIlceler, setIller, setMahalleler, setOsbler, setShowLoading, setTapuIlceler, setTapuIller, setTapuMahalleler } from '../../features/sharedSlice';
import { setSelectedFeature } from '../../features/selectionSlice';
import { setFitGeom, setHighlightAll } from '../../features/mapSlice';
import { useTranslation } from 'react-i18next';
interface Props {
    zindex?: { search: boolean, categorical: boolean }
}


export default function Search(props: Props) {
    const [openAdvance, setOpenAdvance] = useState(false)
    const [searchText, setSearchText] = useState<string>('');
    const [searchInterval, setSearchInterval] = useState<any>(undefined);
    const [quickSearchList, setQuickSearchList] = useState<any[]>([]);
    const [parcelSearchVisibility, setParcelSearchVisibility] = useState<boolean>(false);
    const [firmVisibility, setFirmVisibility] = useState<boolean>(false);
    const [sliderVisibility, setSliderVisibility] = useState<boolean>(false);
    const [cityValues, setCityValues] = useState<any>();
    const [osbValues, setOsbValues] = useState<any>();
    const [selectedCity, setSelectedCity] = useState<any>(null);
    const [selectedOsb, setSelectedOsb] = useState<any>(null);
    const [parcelDomain, setParcelDomain] = useState<any>(null);
    const [selectedParcelDomain, setSelectedParcelDomain] = useState<any>(null);
    const [selectedTax, setSelectedTax] = useState<any>(null);
    const [selectedFirm, setSelectedFirm] = useState<any>(null);
    const [sliderValue, setSliderValue] = useState<any>([0, 5000000]);
    const [filteredFirms, setFilteredFirms] = useState<any>(null);
    const [filteredTax, setFilteredTax] = useState<any>(null);
    const zindex = props.zindex;
    const toast = useRef(null);
    const dispatch = useAppDispatch();
    const services = useAppSelector(state => state.layer.services)
    const layerGroups = useAppSelector(state => state.layer.layerGroups)
    const token = useAppSelector(state => state.authState.token)
    const dataRoles = useAppSelector(state => state.sharedState.dataRoles);
    const { t } = useTranslation()

    useEffect(() => {
        if (services.length > 0 && !cityValues) {
            getCities();
            getOsbler();
            getDistrict();
            getMahalleler();
            getTapuBolgeler();
        }
    }, [services])

    useEffect(() => {
        if (selectedCity) {
            getOSB();
        }
    }, [selectedCity])

    useEffect(() => {
        if (layerGroups) {
            getParcelDomains();
        }
    }, [layerGroups])

    useEffect(() => {
        setQuickSearchList([]);
        if (searchInterval) {
            clearInterval(searchInterval);
        }
        if (searchText.length > 2) {
            const searchTimeout = setTimeout(() => {
                axios.get(process.env.REACT_APP_BASE_URL + `rest/v1/search?search=${searchText}`)
                    .then(response => {
                        setQuickSearchList(response.data.result);
                    })
            }, 250);
            setSearchInterval(searchTimeout);
        }
    }, [searchText])

    const serchFirmOrTaxNo = () => {
        if (selectedTax && selectedTax.id) {
            getFirmGeoms(selectedTax.id)
            setSelectedFirm(undefined)
        }
        if (selectedFirm && selectedFirm.id) {
            getFirmGeoms(selectedFirm.id)
            setSelectedTax(undefined)
        }
    }

    const getCities = async () => {
        const serviceUrl = services.filter(obj => obj.type === 'VECTOR')[0].url
        if (serviceUrl) {
            try {
                const response = await axios.get(serviceUrl! + `/ows?service=WFS&version=1.0.0&request=getfeature&outputFormat=application/json&typeName=il_usr&propertyname=adi` + (token ? `&token=${token}` : ''))
                dispatch(setIller(response.data.features.map(((value: any) => value.properties))))
                const cityValues = response.data.features.map(((value: any) => value.properties))
                setCityValues(cityValues)
            } catch (error) {
                console.error(error);
            }
        }
    }

    const getOsbler = async () => {
        const serviceUrl = services.filter(obj => obj.type === 'VECTOR')[0].url
        if (serviceUrl) {
            const response = await axios.get(serviceUrl! + `/ows?service=WFS&version=1.0.0&request=getfeature&outputFormat=application/json&typeName=osb_sinir_usr&propertyname=adi,id`)
            const osbValues = response.data.features.map(((value: any) => value.properties))
            dispatch(setOsbler(osbValues))
        }
    }

    const getDistrict = async () => {
        const serviceUrl = services.filter(obj => obj.type === 'VECTOR')[0].url
        if (serviceUrl) {
            axios.get(serviceUrl! + `/ows?service=WFS&version=1.0.0&request=getfeature&outputFormat=application/json&typeName=ilce_usr&propertyname=adi,ilce_kodu,il_kodu` + (token ? `&token=${token}` : ''))
                .then( resp => {
                    dispatch(setIlceler(resp.data.features.map(((value: any) => value.properties))))
                })
                .catch(err => {
                    console.error(err);
                })
        }
    }

    const getMahalleler = async () => {
        const serviceUrl = services.filter((obj: any) => obj.type === 'VECTOR')[0].url
        if (serviceUrl) {
            axios.get(serviceUrl! + `/ows?service=WFS&version=1.0.0&request=getfeature&outputFormat=application/json&typeName=mahalle&propertyname=adi,mah_id` + (token ? `&token=${token}` : ''))
            .then( resp => {
                dispatch(setMahalleler(resp.data.features.map(((value: any) => value.properties)))) 
            })
            .catch( err => {
                console.error(err);
            })
        }
    }

    const getTapuBolgeler = async () => {
        try {
            const serviceUrl = services.filter((obj: any) => obj.type === 'VECTOR')[0].url
            if (serviceUrl) {
                axios.get(serviceUrl! + `/ows?service=WFS&version=1.0.0&request=getfeature&outputFormat=application/json&typeName=tapu_il&propertyname=ad,id,plakakodu` + (token ? `&token=${token}` : ''))
                    .then(resp => {
                        dispatch(setTapuIller(resp.data.features.map(((value: any) => value.properties))))
                    })
                    .catch( err => { console.log(err)})                   
                axios.get(serviceUrl! + `/ows?service=WFS&version=1.0.0&request=getfeature&outputFormat=application/json&typeName=tapu_ilce&propertyname=ad,id,ilid,featureid` + (token ? `&token=${token}` : ''))
                    .then(resp => {
                        dispatch(setTapuIlceler(resp.data.features.map(((value: any) => value.properties))))
                    })
                    .catch( err => { console.log(err)})                
                axios.get(serviceUrl! + `/ows?service=WFS&version=1.0.0&request=getfeature&outputFormat=application/json&typeName=tapu_mahalle&propertyname=ad,id,ilceid` + (token ? `&token=${token}` : ''))
                    .then(resp => {
                        dispatch(setTapuMahalleler(resp.data.features.map(((value: any) => value.properties))))
                    })
                    .catch( err => { console.log(err)})
            }
        } catch (error) {
            console.error(error);
        }
    }

    const getOSB = async () => {
        const serviceUrl = services.filter(obj => obj.type === 'VECTOR')[0].url
        if (serviceUrl) {
            const response = await axios.get(serviceUrl! + `/ows?service=WFS&version=1.0.0&request=getfeature&outputFormat=application/json&typeName=osb_sinir_usr&propertyname=adi,il_kodu&cql_filter=il_kodu=${selectedCity.id}` + (token ? `&token=${token}` : ''))
            const osbValues = response.data.features.map(((value: any) => value.properties))
            setOsbValues(osbValues)
        }
    }

    const getParcelDomains = async () => {
        const parselLayer = layerGroups.find(layerGroup => layerGroup.name === 'parsel')?.layers.find(layer => layer.name === 'parsel_usr')
        const findedDomain = parselLayer?.fields.find((field: IField) => field.name === 'tahsis_durumu')
        setParcelDomain(findedDomain?.domain);
    }

    const getFirmGeoms = async (firmId: number) => {
        const serviceUrl = services.filter(obj => obj.type === 'VECTOR')[0].url
        if (serviceUrl) {
            const response = await axios.get(serviceUrl! + `/ows?service=WFS&version=1.0.0&request=getfeature&outputFormat=application/json&typeName=parsel_firma&CQL_FILTER=firma_id=${firmId}` + (token ? `&token=${token}` : ''));
            const features = response.data.features;
            let promiseArray: any = []
            features.map((feature: any) => {
                const response = axios.get(serviceUrl! + `/ows?service=WFS&version=1.0.0&request=getfeature&outputFormat=application/json&typeName=parsel_usr&CQL_FILTER=id=${feature.properties.parsel_id}` + (token ? `&token=${token}` : ''));
                promiseArray.push(response);
            })
            Promise.all(promiseArray).then((responseArray) => {
                const featureArray = [];
                for (const response of responseArray) {
                    if (response.data.features) {
                        featureArray.push(...response.data.features)
                    }
                }
                if (featureArray.length > 0) {
                    dispatch(setHighlightAll(featureArray));
                    dispatch(setFitGeom(featureArray[0].geometry));
                }
            })
        }
    }

    const searchFirm = async (event: { query: string }) => {

        if (event.query.length > 2) {
            const response = await axios.get(process.env.REACT_APP_BASE_URL + `rest/v1/osb-parsel/firma/filter/${event.query.toLocaleLowerCase('tr')}` + (token ? `?token=${token}` : ''));
            setFilteredFirms(response.data.data.map((entry: any) => entry));
        }
    }
    const searchTax = async (event: { query: string }) => {

        if (event.query.length > 2) {
            const serviceUrl = services.filter(obj => obj.type === 'VECTOR')[0].url
            const response = await axios.get(serviceUrl! + `/ows?service=WFS&version=1.0.0&request=getfeature&outputFormat=application/json&typeName=firma&CQL_FILTER=(strStartsWith(vergi_no,'${event.query}') = true)` + (token ? `&token=${token}` : ''));
            setFilteredTax(response.data.features.map((feature: any) => feature.properties));
        }
    }

    const clickOnQuickSearch = async (e: any) => {
        const searchFeature = e.value;
        const service = services.find(service => { return service.layers.some(layer => layer.name === searchFeature.layer_name) })
        if (service) {
            try {
                const response = await axios.get(service!.url + `/ows?service=WFS&version=1.0.0&crsName=EPSG:4326&request=getfeature&featureId=${searchFeature.id}&typeName=${searchFeature.layer_name}&outputFormat=application/json` + (token ? `&token=${token}` : ''))
                const feature :any = response.data.features[0]
                dispatch(setSelectedFeature(feature));
                dispatch(setFirmResult(feature));
                
            } catch (error) {
                console.log(error);
            }
        }
        setQuickSearchList([]);
        setSearchText('')
    }

    const searchParcel = async () => {
        dispatch(setHighlightAll(undefined));

        const serviceUrl = services.filter(obj => obj.type === 'VECTOR')[0].url
        if (serviceUrl) {
            try {
                dispatch(setShowLoading(true));
                let fitGeom;
                if (selectedCity && !selectedOsb) {
                    const response = await axios.get(serviceUrl! +
                        `/ows?service=WFS&version=1.0.0&request=getfeature&outputFormat=application/json&typeName=il_usr&CQL_FILTER=kodu=${selectedCity.id}` + (token ? `&token=${token}` : ''))
                    fitGeom = response.data.features[0].geometry;
                }
                if (selectedCity && selectedOsb) {
                    const response = await axios.get(serviceUrl! +
                        `/ows?service=WFS&version=1.0.0&request=getfeature&outputFormat=application/json&typeName=osb_sinir_usr&CQL_FILTER=id=${selectedOsb.id}` + (token ? `&token=${token}` : ''))
                    fitGeom = response.data.features[0].geometry;
                }
                let cql_filter = `il_kodu=${selectedCity.id}`
                selectedOsb ? cql_filter += ` and sb_id=${selectedOsb.id}` : cql_filter = cql_filter
                if (selectedParcelDomain.id === 1) {
                    selectedParcelDomain ? cql_filter += ` and not tahsis_durumu=2` : cql_filter = cql_filter
                    cql_filter += ` and parsel_niteligi=1`
                }
                else {
                    selectedParcelDomain ? cql_filter += ` and tahsis_durumu=${selectedParcelDomain.id}` : cql_filter = cql_filter
                }
                cql_filter += ` and  parsel_alani between ${sliderValue[0]} and ${sliderValue[1]}`
                const parselLayer = layerGroups.find(layerGroup => layerGroup.name === 'Osb')?.layers.find(layer => layer.name === 'parsel_usr')
                let filteredFields = parselLayer?.fields.filter((obj: any) => obj.name !== 'geom' && obj.type !== 'Attachment')
                const layerPerm = dataRoles.find((obj: any) => obj.layer_id === parselLayer?.id && obj.field_id === null)
                if (!layerPerm) {
                    const layerPerm = dataRoles.filter((obj: any) => obj.layer_id === parselLayer?.id)
                    const fieldIds = layerPerm.map((obj: any) => obj.field_id)
                    filteredFields = parselLayer?.fields.filter(obj => fieldIds.includes(obj.id) && obj.name !== 'geom' && obj.type !== 'Attachment');
                }
                const properties = filteredFields?.map((field: any) => field.name).join(',')
                let results;
                if (filteredFields) {
                    let url = serviceUrl! + `/ows?service=WFS&version=1.0.0&request=getfeature&outputFormat=application/json&typeName=parsel_usr&CQL_FILTER=${cql_filter}&propertyName=${properties}`
                    if (token) {
                        url += `&token=${token}`
                    }
                    const response = await axios.get(url)
                    results = response.data.features;
                } else {
                    let url = serviceUrl! + `/ows?service=WFS&version=1.0.0&request=getfeature&outputFormat=application/json&typeName=parsel_usr&CQL_FILTER=${cql_filter}`
                    if (token) {
                        url += `&token=${token}`
                    }

                    const response = await axios.get(url);
                    results = response.data.features;
                }
                dispatch(setFitGeom(fitGeom));
                dispatch(setHighlightAll(results));
                
            } catch (error) {
                console.error(error);
                dispatch(setShowLoading(false));
            }
        }
    }

    return (
        <div className={`${zindex?.search || zindex?.categorical ? 'search-container index' : 'search-container'} `}>
            <Toast ref={toast} position='bottom-center' />
            <div className='p-input-icon-right search-input-container'>
                <i className={`search-icon pi ${openAdvance || zindex?.categorical ? 'pi-angle-double-up' : 'pi-angle-double-down'}`} onClick={() => { setOpenAdvance(!openAdvance) }} />
                <InputText style={{ height: '35px' }} value={searchText} onChange={(e) => setSearchText(e.target.value)} placeholder={t('TEXT.Search')} />
            </div>
            {
                (openAdvance || zindex?.categorical) &&
                <Card>
                    <div className='category '>
                        <div className='header' onClick={() => setParcelSearchVisibility(!parcelSearchVisibility)}>
                            <i className={parcelSearchVisibility ? 'pi pi-angle-down' : 'pi pi-angle-right'}></i>
                            <p>{t('TEXT.Parcel Search')}</p>
                        </div>
                        {parcelSearchVisibility && <div className='content'>
                            <Dropdown value={selectedCity} options={cityValues} onChange={(e) => setSelectedCity(e.value)} optionLabel='adi' filter showClear filterBy='adi' placeholder={t('TEXT.Select City')} />
                            <Dropdown value={selectedOsb} options={osbValues} onChange={(e) => setSelectedOsb(e.value)} optionLabel='adi' filter showClear filterBy='adi' placeholder={t('TEXT.Select Osb')} />
                            <div className='group'>
                                <span className='p-input-icon-right' onClick={() => setSliderVisibility(!sliderVisibility)}>
                                    <i className='pi pi-chevron-down' />
                                    <InputText value={t('TEXT.Parcel Area') + ' ' + sliderValue} disabled />
                                </span>
                                {
                                    sliderVisibility && <div className='box'>
                                        {t('TEXT.Field Range')} : {sliderValue[0]}m², {sliderValue[1]}m²
                                        <Slider value={sliderValue} min={0} max={5000000} step={50} onChange={(e) => setSliderValue(e.value)} range />
                                    </div>
                                }
                            </div>
                            <Dropdown value={selectedParcelDomain} options={parcelDomain} onChange={(e) => setSelectedParcelDomain(e.value)} optionLabel='desc' filter showClear filterBy='desc' placeholder={t('TEXT.Parcel Status')} />
                            <Button label={t('TEXT.Search2')} onClick={searchParcel} disabled={!selectedCity} className={!selectedCity ? 'disabled' : ''} />
                        </div>}
                        <div className='header' onClick={() => setFirmVisibility(!firmVisibility)}>
                            <i className={firmVisibility ? 'pi pi-angle-down' : 'pi pi-angle-right'}></i>
                            <p>{t('TEXT.Firm Search')}</p>
                        </div>
                        {firmVisibility &&
                            <div className='content'>
                                <AutoComplete value={selectedFirm} suggestions={filteredFirms} completeMethod={searchFirm} field="firma_adi" placeholder={t('TEXT.Firm Search')} onChange={(e) => setSelectedFirm(e.value)} aria-label="Firms" />
                                <AutoComplete value={selectedTax} suggestions={filteredTax} completeMethod={searchTax} field="vergi_no" placeholder={t('TEXT.Enter Tax No')} onChange={(e) => setSelectedTax(e.value)} aria-label="Tax No" />
                                <Button label={t('TEXT.Search2')} onClick={() => serchFirmOrTaxNo()} disabled={!selectedTax && !selectedFirm} className={!selectedTax && !selectedFirm ? 'disabled' : ''} />
                            </div>
                        }
                    </div>
                </Card>
            }
            {
                quickSearchList.length > 0 &&
                <Card title={'Arama Sonucu (' + quickSearchList.length + ')'}>
                    <ListBox options={quickSearchList} onChange={clickOnQuickSearch} optionLabel={quickSearchList[0].search_field}
                        style={{ maxHeight: '500px', overflow: 'auto' }}>
                    </ListBox>
                </Card>
            }
        </div>
    )
}
